import React, { useCallback, useEffect, useRef } from "react";
import "../../../../assets/css/multiRangeSlider.css";

 export const MultiRangeSlider = ({ minNps, maxNps,setMinNps,setMaxNps}) => {
  const minValRef = useRef(minNps);
  const maxValRef = useRef(maxNps);
  const range = useRef(null);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - minNps) / (maxNps - minNps)) * 100),
    [minNps, maxNps]
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = Math.round((minNps/ 100) * 100);
    const maxPercent = Math.round((maxValRef.current/ 100) * 100)

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minNps, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = Math.round((minValRef.current/ 100) * 100);
    const maxPercent = Math.round((maxNps/ 100) * 100);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxNps, getPercent]);

  // Get minNps and maxNps values when their state changes
  useEffect(() => {
      setMaxNps(maxNps)
      setMinNps(minNps)
  }, [minNps, maxNps]);

  return (
    <div className="multiRangeContainer">
      <input
        type="range"
        minNps={minNps}
        maxNps={maxNps}
        value={minNps}
        onChange={(event) => {
          const value = Math.min(Number(event.target.value), maxNps - 1);
          setMinNps(value);
          minValRef.current = value;
        }}
        className="thumb thumb--left"
        style={{ zIndex: minNps > maxNps - 100 && "5" }}
      />
      <input
        type="range"
        minNps={minNps}
        maxNps={maxNps}
        value={maxNps}
        onChange={(event) => {
          const value = Math.max(Number(event.target.value), minNps + 1);
          setMaxNps(value);
          maxValRef.current = value;
        }}
        className="thumb thumb--right"
      />

      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        <div className="slider__left-value">{minNps}</div>
        <div className="slider__right-value">{maxNps}</div>
      </div>
    </div>
  );
};


